import SlideUpDown from 'vue-slide-up-down'

export default {
  SlideUpDown
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/schedule/resources/components.js